export default __webpack_public_path__ + "images/b3c01a1532605de57014ddb09c256650.svg";